import cookies from 'js-cookie';
import activateForm from './forms/activateForm';
import resetForm from './forms/resetForm';

const stickies = {};
let register;
let show;
let hide;

const initialize = () => {
  if (!register) {
    // Create reusable elements
    const $layout = $('.mdl-layout');
    const $sticky = $('<div class="sticky initializing"><input id="sticky__toggle-input" class="sticky__toggle-input" type="checkbox" /></div>').appendTo($layout);
    const $stickyCloseButton = $('<div class="sticky__close-button">Close</div>').appendTo($sticky);
    const $stickyTitle = $('<h3 class="sticky__title"></h3>').appendTo($sticky);
    const $stickyContent = $('<div class="sticky__content"></div>').appendTo($sticky);
    const $scrollContainer = $('.mdl-layout__content');

    register = (sticky) => {
      const delay = sticky.getAttribute('delay') * 1000;
      stickies[sticky.getAttribute('id')] = $(sticky).remove();
      if (!delay) {
        return;
      }
      setTimeout(() => {
        if (!cookies.get('footer-cta-closed')) {
          show(sticky.getAttribute('title'), sticky.getAttribute('id'));
        }
      }, delay);
      // $scrollContainer.on('scroll.showSticky', ({ target: scrollContainer }) => {
      //   if (scrollContainer.scrollTop > 0 && !cookies.get('footer-cta-closed')) {
      //     show(sticky.getAttribute('title'), sticky.getAttribute('id'));
      //     $scrollContainer.off('scroll.showSticky');
      //   }
      // });
    };

    show = (title, stickyId) => {
      let $content;
      if (typeof stickyId !== 'undefined') {
        $content = stickies[stickyId].clone(true, true);
        $content.appendTo($stickyContent.empty());
        activateForm($('.form', $content));
      }
      if (typeof title !== 'undefined') {
        $stickyTitle.text(title);
      }
      $sticky.removeClass('initializing');
      $sticky.addClass('sticky--active');
      return $content;
    };

    hide = () => {
      $sticky.removeClass('sticky--active');
      resetForm($('form', $sticky));
      cookies.set('footer-cta-closed', (new Date()).getTime());
    };

    // Add default click handlers
    $stickyCloseButton.on('click', hide);

    // Automatically register stickies
    Array.from(document.getElementsByTagName('Sticky')).forEach(register);
  }
  return { show, hide, register };
};

export default initialize;
export const showSticky = (title, stickyId) => {
  initialize().show(title, stickyId);
};
export const hideSticky = () => {
  initialize().hide();
};
